import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  createUser(user: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(this.baseUrl + '/v1/pre-registration', user, {
      headers,
    });
  }

  editUser(userId: string | null, userData: any) {
    return this.http.patch(this.baseUrl + `/v1/usuario/${userId}`, userData);
  }

  deleteUser(id: string) {
    return this.http.delete(this.baseUrl + `/v1/usuario/${id}`);
  }

  finalizeRegistration(form: any, token: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.patch(this.baseUrl + '/v1/finalize-registration', form, {
      headers,
    });
  }
  passwordRecover(form: any, token: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    return this.http.post(this.baseUrl + '/v1/users/password-recover', form, {
      headers,
    });
  }

  getUsers(
    pageIndex: number = 0,
    pageSize: number = 10,
    sortDirection: string = '',
    sortProperty: string = '',
    nameOrEmail: string = '',
    statusFilter: string = '',
    profileUserId: string = ''
  ) {
    return this.http.get(
      this.baseUrl +
      `/v1/usuarios?page=${pageIndex}&size=${pageSize}&sortField=${sortProperty}&sortDirection=${sortDirection}&nomeAndEmail=${nameOrEmail}&status=${statusFilter}&profileUserId=${profileUserId}`
    );
  }
  getUsersByName(
    pageIndex: number = 0,
    pageSize: number = 10,
    sortDirection: string = '',
    sortProperty: string = '',
    nameOrEmail: string = '',
    statusFilter: string = '',
    profileUserId: string = ''
  ) {
    return this.http.get(
      this.baseUrl +
      `/v1/usuarios?page=${pageIndex}&size=${pageSize}&sortField=${sortProperty}&sortDirection=${sortDirection}&nome=${nameOrEmail}&status=${statusFilter}&profileUserId=${profileUserId}`
    );
  }
  getUser(userId: string) {
    return this.http.get(this.baseUrl + `/v1/usuario/${userId}`);
  }
  getTerm() {
    return this.http.get(this.baseUrl + `/v1/term-of-use-active`);
  }

  activate(id: number) {
    return this.http.patch(this.baseUrl + `/v1/usuario/${id}/active`, {});
  }

  inactivate(id: number) {
    return this.http.patch(this.baseUrl + `/v1/usuario/${id}/inactive`, {});
  }

  sendEmailRecovery(email: string) {
    return this.http.post(this.baseUrl + '/v1/create-password-recover', email);
  }

  getMenuUsuario(userId: string) {
    return this.http.get(this.baseUrl + `/v1/menu-usuario/${userId}`);
  }
}
